import { render, staticRenderFns } from "./TransportsStep.vue?vue&type=template&id=a46d0882&scoped=true&"
import script from "./TransportsStep.vue?vue&type=script&lang=js&"
export * from "./TransportsStep.vue?vue&type=script&lang=js&"
import style0 from "./TransportsStep.vue?vue&type=style&index=0&id=a46d0882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46d0882",
  null
  
)

export default component.exports